import classnames from 'classnames';
import { ErrorBoundary } from 'components/Errors/ErrorBoundary';
import LoadingScreen from 'components/LoadingScreen';
import { useAtom } from 'jotai';
import { ensureAccessTokenVerified } from 'lib/auth';
import React, { Suspense, useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

// import { companyIdAtom } from 'views/state';
import AccountsList from './Accounts';

import './styles.css'; // Import custom CSS file for styling
import AddRepositories from './components/AddRepositories';
import { handleSastOAuthReceived } from './helper';
import NewIntegration from './NewAccountIntegration';
import RepositoriesList from './Repositories';
import { currentTabAtom } from './state';
import { SastTab } from './types';

const SAST2 = () => {
  const url = window.location.href;
  const [currentScreen, setCurrentScreen] = useState<
    'new' | 'tabs' | 'add_repos'
  >('tabs');
  const [currentTab, setCurrentTab] = useAtom(currentTabAtom);

  useEffect(() => {
    ensureAccessTokenVerified();

    // Handle OAuth redirect
    if (handleSastOAuthReceived()) return;
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    // Get the value of a specific parameter
    const value = urlParams.get('t');

    console.log(value);
    // tab id
    switch (value) {
      case 'new':
        setCurrentScreen('new');
        break;
      case 'add_repos':
        setCurrentScreen('add_repos');
        break;
      case 'account':
        setCurrentScreen('tabs');
        setCurrentTab(SastTab.AccountsList);
        break;
      case 'repo':
        setCurrentScreen('tabs');
        setCurrentTab(SastTab.RepositoriesList);
        break;
      default:
        setCurrentScreen('tabs');
        setCurrentTab(SastTab.RepositoriesList);
    }
  }, [url]);

  const TabLink = ({ title, tabId }) => {
    return (
      <NavItem>
        <NavLink
          className={classnames({ active: currentTab === tabId })}
          onClick={() => {
            setCurrentTab(tabId);
            // reset the url hash
            // window.location.hash = '';
          }}
        >
          {tabId === SastTab.RepositoriesList ? (
            <>
              <span>R</span>
              <span>E</span>
              <span>P</span>
              <span>O</span>
              <span>S</span>
              <span>I</span>
              <span>T</span>
              <span>O</span>
              <span>R</span>
              <span>I</span>
              <span>E</span>
              <span>S</span>
            </>
          ) : (
            <>
              <span>A</span>
              <span>C</span>
              <span>C</span>
              <span>O</span>
              <span>U</span>
              <span>N</span>
              <span>T</span>
              <span>S</span>
            </>
          )}
        </NavLink>
      </NavItem>
    );
  };

  return (
    <Suspense fallback={<LoadingScreen />}>
      {/* <div className="content vertical-tabs-container"> */}
      <div className="content">
        <ErrorBoundary>
          {currentScreen === 'new' && <NewIntegration />}
          {currentScreen === 'tabs' && (
            <>
              <div className="d-flex">
                <Nav style={{ cursor: 'pointer' }} tabs>
                  <TabLink
                    title="Repositories"
                    tabId={SastTab.RepositoriesList}
                  />
                  <TabLink title="Accounts" tabId={SastTab.AccountsList} />
                </Nav>
              </div>
              <TabContent activeTab={currentTab} className="tab-content">
                <TabPane tabId={SastTab.AccountsList}>
                  {currentTab === SastTab.AccountsList && (
                    <Suspense fallback={<LoadingScreen />}>
                      <AccountsList />
                    </Suspense>
                  )}
                </TabPane>
                <TabPane tabId={SastTab.RepositoriesList}>
                  {currentTab === SastTab.RepositoriesList && (
                    <Suspense fallback={<LoadingScreen />}>
                      <RepositoriesList />
                    </Suspense>
                  )}
                </TabPane>
              </TabContent>
            </>
          )}
          {currentScreen === 'add_repos' && <AddRepositories />}
        </ErrorBoundary>
      </div>
      <ToastContainer />
    </Suspense>
  );
};

export default SAST2;
